import Image from "next/image";
import goomy from "@/assets/img/goomy2.png";

const MenuGoomy = () => (
  <Image priority alt="Goomy!" className="menu-goomy" src={goomy}></Image>
);

export default MenuGoomy;
